export default __webpack_public_path__ + "static/media/waoo-pepe.2192aea2.gif";